import { jsx as _jsx } from "react/jsx-runtime";
import { SPRING_CONFIG_SNAPPY } from '#pplx/frontend/aether/config.js';
import { lazy, Suspense } from 'react';
/**
 * Internal implementation - lazy loaded to avoid bundling react-spring
 */
const MotionFadeImpl = lazy(async () => {
    const { animated, useTransition } = await import('@react-spring/web');
    function MotionFadeImpl({ isVisible, children, className, onDestroyed, }) {
        const transitions = useTransition(isVisible, {
            from: { opacity: 0 },
            enter: { opacity: 1 },
            leave: { opacity: 0 },
            config: { ...SPRING_CONFIG_SNAPPY, clamp: true },
            onDestroyed: onDestroyed,
        });
        return transitions((style, item) => item ? (_jsx(animated.div, { style: style, className: className, children: children })) : null);
    }
    return { default: MotionFadeImpl };
});
/**
 * Fade animation component with Suspense built-in.
 * Lazy loads react-spring only when used.
 */
export function MotionFade(props) {
    return (_jsx(Suspense, { fallback: null, children: _jsx(MotionFadeImpl, { ...props }) }));
}
//# sourceMappingURL=MotionFade.js.map